import styled from "react-emotion/macro"

export const Wrapper = styled("img")`
  font-family: 'object-fit: ${(props) => props.fit}; object-position: ${(
  props,
) => props.position}';
  object-fit: ${(props) => props.fit};
  object-position: ${(props) => props.position};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ImageFit/style.js